import { render, staticRenderFns } from "./BlocoTotalizadorMonitoramentoSocioambiental.vue?vue&type=template&id=0b850b28&scoped=true&lang=pug"
import script from "./BlocoTotalizadorMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoTotalizadorMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoTotalizadorMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=0b850b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b850b28",
  null
  
)

export default component.exports